import React from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"

import styles from "../../css/Page.module.css"

const FinalInvoice = props => {
  return (
    <div>
      <Header title="Om det finns kostnad för slutfaktura, vem skall stå för denna?" />
      <div className={styles.inputContainer}>
        <Input
          name="finalInvoiceCostChoice"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
        />
      </div>
      {/*<NavigationButtons
        inputState={props.inputState}
  />*/}
    </div>
  )
}
  
export default FinalInvoice